import '@proj-airi/font-cjkfonts-allseto/index.css'
import '@proj-airi/font-xiaolai/index.css'
import '@unocss/reset/tailwind.css'
import './styles/main.css'
import './styles/public-site.css'
import 'uno.css'

async function mountStageWeb() {
  const { mountPublicSiteApp } = await import('./public-entry')
  mountPublicSiteApp()
}

void mountStageWeb().catch(error => console.error(error))
